import { BUSINESS } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-secondary/30" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10 mb-14">
          <div>
            <span className="font-serif text-3xl text-foreground">Platinum</span>
            <span className="block text-[10px] tracking-[0.35em] uppercase text-primary mt-1">Auto &amp; Home</span>
            <p className="text-muted-foreground font-light mt-5 max-w-xs leading-relaxed">
              Obsessive interior detailing for vehicles and homes across {BUSINESS.location}.
            </p>
          </div>
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-5">Navigate</p>
            <ul className="space-y-3">
              {[["Services", "#services"], ["Process", "#process"], ["Work", "#work"], ["Reviews", "#testimonials"], ["Book", "#book"], ["Custom Quote", "#quote"], ["Contact", "#contact"]].map(([l, h]) => (
                <li key={h}><a href={h} className="text-foreground/80 hover:text-primary transition-colors" data-testid={`footer-link-${l.toLowerCase()}`}>{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-5">Contact</p>
            <ul className="space-y-3">
              <li><a href={BUSINESS.phoneHref} className="text-foreground/80 hover:text-primary transition-colors" data-testid="footer-phone">{BUSINESS.phone}</a></li>
              <li><a href={`mailto:${BUSINESS.emailAuto}`} className="text-foreground/80 hover:text-primary transition-colors break-all" data-testid="footer-email-auto">{BUSINESS.emailAuto}</a></li>
              <li><a href={`mailto:${BUSINESS.emailHome}`} className="text-foreground/80 hover:text-primary transition-colors break-all" data-testid="footer-email-home">{BUSINESS.emailHome}</a></li>
              <li className="text-foreground/80">{BUSINESS.location}</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-border flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground tracking-wide">
          <span>&copy; {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
          <span>Crafted with the Platinum standard.</span>
        </div>
      </div>
    </footer>
  );
}
